$(function () {
  const btn = $("#page_top");
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 200) {
      btn.addClass("active");
    } else {
      btn.removeClass("active");
    }
  });

  btn.click(function () {
    $("html, body").animate({ scrollTop: 0 }, 500);
    return false;
  });
});
